import arrowSquareLeft from '../../assets/arrow-square-left.svg';
import arrowSquareRight from '../../assets/arrow-square-right.svg';
import colors from '../../theme/tokens/colors';

const DATE_SELECTION_BG = colors.yovoRed[400];
const DATE_RANGE_BG = 'rgba(255, 222, 229, 0.56)';

/** Homepage calendar CSS, injected only while Homepage is mounted. Also carries the AI-guide gradient animation that shares this style tag. */
export const datePickerStyles = `
    .custom-datepicker {
      border: none !important;
      box-shadow: none !important;
      font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif !important;
      width: 100% !important;
    }
    
    .custom-datepicker .react-datepicker__header {
      background-color: #000 !important;
      border-bottom: 1px solid #333 !important;
      border-radius: 6px 6px 0 0 !important;
      padding: 8px 0 !important;
    }
    
    .custom-datepicker .react-datepicker__current-month {
      color: #fff !important;
      font-weight: 600 !important;
      font-size: 16px !important;
    }
    
    .custom-datepicker .react-datepicker__day-name {
      color: #666 !important;
      font-weight: 500 !important;
      font-size: 11px !important;
      width: calc(100% / 7 - 1px) !important;
      flex: 1 !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      margin: 0.5px !important;
      height: 24px !important;
      line-height: 22px !important;
    }
    
    .custom-datepicker .react-datepicker__day {
      color: #333 !important;
      font-weight: 400 !important;
      border-radius: 3px !important;
      margin: 0.5px !important;
      width: calc(100% / 7 - 1px) !important;
      height: 32px !important;
      line-height: 30px !important;
      flex: 1 !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      font-size: 13px !important;
    }
    
    .custom-datepicker .react-datepicker__day:hover {
      background-color: #f0f0f0 !important;
      color: #000 !important;
    }
    
    .custom-datepicker .react-datepicker__day--selected {
      background-color: #000 !important;
      color: white !important;
    }
    
    .custom-datepicker .react-datepicker__day--in-selecting-range {
      background-color: #f0f0f0 !important;
      color: #000 !important;
    }
    
    .custom-datepicker .react-datepicker__day--in-range {
      background-color: #f0f0f0 !important;
      color: #000 !important;
    }
    
    .custom-datepicker .react-datepicker__day--range-start,
    .custom-datepicker .react-datepicker__day--range-end {
      background-color: #000 !important;
      color: white !important;
    }
    
    .custom-datepicker .react-datepicker__day--disabled {
      color: #ccc !important;
    }
    
    .custom-datepicker .react-datepicker__navigation {
      top: 8px !important;
    }
    
    .custom-datepicker .react-datepicker__navigation--previous {
      left: 8px !important;
    }
    
    .custom-datepicker .react-datepicker__navigation--next {
      right: 8px !important;
    }
    
    .custom-datepicker .react-datepicker__navigation-icon::before {
      border-color: #fff !important;
    }
    
    .custom-datepicker .react-datepicker__navigation:hover .react-datepicker__navigation-icon::before {
      border-color: #ccc !important;
    }
    
    .custom-datepicker .react-datepicker__month-container {
      width: 100% !important;
    }
    
    .custom-datepicker .react-datepicker__month {
      width: 100% !important;
    }
    
    .custom-datepicker .react-datepicker__week {
      width: 100% !important;
      display: flex !important;
      justify-content: space-between !important;
    }
    
    .custom-datepicker .react-datepicker__day-names {
      width: 100% !important;
      display: flex !important;
      justify-content: space-between !important;
    }

    /* Two Month Calendar Styles */
    .custom-datepicker-two-month {
      border: none !important;
      box-shadow: none !important;
      font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif !important;
      width: 100% !important;
    }
    
    .custom-datepicker-two-month .react-datepicker {
      display: flex !important;
      flex-direction: row !important;
      gap: 12px !important;
      align-items: flex-start !important;
      padding: 0 !important;
      width: 100% !important;
    }
    
    
    .custom-datepicker-two-month .react-datepicker__header {
      background-color: transparent !important;
      border-bottom: none !important;
      padding: 0 !important;
      margin-bottom: 8px !important;
    }
    
    .custom-datepicker-two-month .react-datepicker__current-month {
      color: #000 !important;
      font-weight: 600 !important;
      font-size: 13px !important;
      margin-bottom: 8px !important;
      text-align: center !important;
    }
    
    .custom-datepicker-two-month .react-datepicker__day-names {
      display: flex !important;
      justify-content: space-between !important;
      margin-bottom: 4px !important;
    }
    
    .custom-datepicker-two-month .react-datepicker__day-name {
      color: #545665 !important;
      font-weight: 600 !important;
      font-size: 10px !important;
      text-transform: uppercase !important;
      margin: 0 !important;
      padding: 4px 0 !important;
      width: 28px !important;
      text-align: center !important;
      flex: 1 !important;
    }
    
    .custom-datepicker-two-month .react-datepicker__month {
      margin: 0 !important;
      padding: 0 !important;
      width: 100% !important;
    }
    
    .custom-datepicker-two-month .react-datepicker__week {
      display: flex !important;
      justify-content: space-between !important;
      margin: 0 !important;
      margin-bottom: 2px !important;
    }
    
    .custom-datepicker-two-month .react-datepicker__day {
      color: #333 !important;
      font-weight: 500 !important;
      font-size: 11px !important;
      border-radius: 0 !important;
      margin: 0 !important;
      width: 28px !important;
      height: 28px !important;
      line-height: 28px !important;
      text-align: center !important;
      flex: 1 !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
    }
    
    .custom-datepicker-two-month .react-datepicker__day:hover {
      background-color: #f5f5f5 !important;
      color: #333 !important;
    }
    
    .custom-datepicker-two-month .react-datepicker__day--selected {
      background-color: ${DATE_SELECTION_BG} !important;
      color: #fff !important;
    }
    
    .custom-datepicker-two-month .react-datepicker__day--in-selecting-range {
      background-color: ${DATE_RANGE_BG} !important;
      color: #333 !important;
    }
    
    .custom-datepicker-two-month .react-datepicker__day--in-range {
      background-color: ${DATE_RANGE_BG} !important;
      color: #333 !important;
    }
    
    .custom-datepicker-two-month .react-datepicker__day--range-start {
      background-color: ${DATE_SELECTION_BG} !important;
      color: #fff !important;
    }
    
    .custom-datepicker-two-month .react-datepicker__day--range-end {
      background-color: ${DATE_SELECTION_BG} !important;
      color: #fff !important;
    }
    
    /* Remove any unwanted blue highlighting */
    .custom-datepicker-two-month .react-datepicker__day--highlighted {
      background-color: transparent !important;
      color: #333 !important;
    }
    
    .custom-datepicker-two-month .react-datepicker__day--highlighted-custom-1,
    .custom-datepicker-two-month .react-datepicker__day--highlighted-custom-2 {
      background-color: transparent !important;
      color: #333 !important;
    }
    
    /* Ensure only actual selected dates are highlighted */
    .custom-datepicker-two-month .react-datepicker__day--selected:not(.react-datepicker__day--range-start):not(.react-datepicker__day--range-end) {
      background-color: ${DATE_SELECTION_BG} !important;
      color: #fff !important;
    }
    
    /* Prevent highlighting same date in different months for one-way trips */
    .custom-datepicker-two-month .react-datepicker__month-container:nth-child(2) .react-datepicker__day--selected {
      background-color: transparent !important;
      color: #333 !important;
    }
    
    /* Only highlight selected date in the first month for one-way trips */
    .custom-datepicker-two-month .react-datepicker__month-container:first-child .react-datepicker__day--selected {
      background-color: ${DATE_SELECTION_BG} !important;
      color: #fff !important;
    }
    
    .custom-datepicker-two-month .react-datepicker__day--outside-month {
      visibility: hidden !important;
      pointer-events: none !important;
    }
    
    .custom-datepicker-two-month .react-datepicker__day--selected.react-datepicker__day--outside-month {
      background-color: transparent !important;
      color: transparent !important;
      visibility: hidden !important;
    }
    
    .custom-datepicker-two-month .react-datepicker__day--disabled {
      color: #ccc !important;
      background-color: transparent !important;
      cursor: not-allowed !important;
    }
    
    .custom-datepicker-two-month .react-datepicker__day[aria-disabled="true"] {
      color: #ccc !important;
      background-color: transparent !important;
      cursor: not-allowed !important;
    }
    
    /* Remove any default browser highlighting */
    .custom-datepicker-two-month .react-datepicker__day:focus {
      outline: none !important;
      background-color: transparent !important;
    }
    
    /* Ensure clean date selection without cross-month interference */
    .custom-datepicker-two-month .react-datepicker__day--keyboard-selected {
      background-color: transparent !important;
      color: #333 !important;
    }
    
    /* Remove any default active states */
    .custom-datepicker-two-month .react-datepicker__day:active {
      background-color: transparent !important;
    }
    
    .custom-datepicker-two-month .react-datepicker__navigation {
      background-color: transparent !important;
      border: none !important;
      color: ${DATE_SELECTION_BG} !important;
      width: 20px !important;
      height: 20px !important;
      border-radius: 3px !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      top: 0 !important;
    }
    
    /* Responsive navigation container sizing for two-month calendar */
    @media (max-width: 1024px) {
      .custom-datepicker-two-month .react-datepicker__navigation {
        width: 18px !important;
        height: 18px !important;
      }
    }
    
    @media (max-width: 480px) {
      .custom-datepicker-two-month .react-datepicker__navigation {
        width: 16px !important;
        height: 16px !important;
      }
    }
    
    .custom-datepicker-two-month .react-datepicker__navigation:hover {
      background-color: ${DATE_RANGE_BG} !important;
    }
    
    .custom-datepicker-two-month .react-datepicker__navigation--previous {
      left: 8px !important;
    }
    
    .custom-datepicker-two-month .react-datepicker__navigation--next {
      right: 8px !important;
    }
    
    .custom-datepicker-two-month .react-datepicker__navigation-icon::before {
      border-color: ${DATE_SELECTION_BG} !important;
      border-width: 3px 3px 0 0 !important;
      width: 6px !important;
      height: 6px !important;
    }
    
    /* Responsive arrow sizing for two-month calendar */
    @media (max-width: 1024px) {
      .custom-datepicker-two-month .react-datepicker__navigation-icon::before {
        width: 5px !important;
        height: 5px !important;
        border-width: 2.5px 2.5px 0 0 !important;
      }
    }
    
    @media (max-width: 480px) {
      .custom-datepicker-two-month .react-datepicker__navigation-icon::before {
        width: 4px !important;
        height: 4px !important;
        border-width: 2px 2px 0 0 !important;
      }
    }
    
    .custom-datepicker-two-month .react-datepicker__month-container {
      background-color: #fff !important;
      border-radius: 0 !important;
      margin: 0 !important;
      padding: 0 !important;
      width: 100% !important;
      min-width: 180px !important;
    }
    
    .custom-datepicker-two-month .react-datepicker__month-wrapper {
      display: flex !important;
      flex-direction: row !important;
      gap: 12px !important;
      align-items: flex-start !important;
      width: 100% !important;
    }
    
    .custom-datepicker-two-month .react-datepicker__month-container {
      background-color: #fff !important;
      border-radius: 0 !important;
      margin: 0 !important;
      padding: 0 !important;
      width: auto !important;
      min-width: 180px !important;
      display: inline-block !important;
    }
    
    .custom-datepicker-two-month .react-datepicker__month-container + .react-datepicker__month-container {
      margin-left: 12px !important;
    }

    /* Single Month Calendar Styles (for one-way trips) */
    .custom-datepicker-single-month {
      border: none !important;
      box-shadow: none !important;
      font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif !important;
      width: 100% !important;
    }
    
    .custom-datepicker-single-month .react-datepicker {
      display: flex !important;
      justify-content: center !important;
      padding: 0 !important;
      width: 100% !important;
    }
    
    .custom-datepicker-single-month .react-datepicker__header {
      background-color: transparent !important;
      border-bottom: none !important;
      padding: 0 !important;
      margin-bottom: 8px !important;
    }
    
    .custom-datepicker-single-month .react-datepicker__current-month {
      color: #000 !important;
      font-weight: 600 !important;
      font-size: 13px !important;
      margin-bottom: 8px !important;
      text-align: center !important;
    }
    
    .custom-datepicker-single-month .react-datepicker__day-names {
      display: flex !important;
      justify-content: space-between !important;
      margin-bottom: 4px !important;
    }
    
    .custom-datepicker-single-month .react-datepicker__day-name {
      color: #545665 !important;
      font-weight: 600 !important;
      font-size: 11px !important;
      text-transform: uppercase !important;
      margin: 0 !important;
      padding: 2px 0 !important;
      width: 40px !important;
      text-align: center !important;
      flex: 1 !important;
    }
    
    .custom-datepicker-single-month .react-datepicker__month {
      margin: 0 !important;
      padding: 0 !important;
      width: 100% !important;
    }
    
    .custom-datepicker-single-month .react-datepicker__week {
      display: flex !important;
      justify-content: space-between !important;
      margin: 0 !important;
      margin-bottom: 2px !important;
    }
    
    .custom-datepicker-single-month .react-datepicker__day {
      color: #333 !important;
      font-weight: 500 !important;
      font-size: 12px !important;
      border-radius: 0 !important;
      margin: 0 !important;
      width: 40px !important;
      height: 42px !important;
      line-height: 1.2 !important;
      text-align: center !important;
      flex: 1 !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      padding: 2px 0 !important;
    }
    
    .custom-datepicker-single-month .react-datepicker__day:hover {
      background-color: #f5f5f5 !important;
      color: #333 !important;
    }
    
    .custom-datepicker-single-month .react-datepicker__day--selected {
      background-color: ${DATE_SELECTION_BG} !important;
      color: #fff !important;
      border-radius: 25% !important;
    }
    
    /* Remove ALL blue highlighting */
    .custom-datepicker-single-month .react-datepicker__day--highlighted {
      background-color: transparent !important;
      color: #333 !important;
    }
    
    .custom-datepicker-single-month .react-datepicker__day--highlighted-custom-1,
    .custom-datepicker-single-month .react-datepicker__day--highlighted-custom-2 {
      background-color: transparent !important;
      color: #333 !important;
    }
    
    .custom-datepicker-single-month .react-datepicker__day--keyboard-selected {
      background-color: transparent !important;
      color: #333 !important;
    }
    
    .custom-datepicker-single-month .react-datepicker__day--today {
      background-color: transparent !important;
      color: #333 !important;
      font-weight: 500 !important;
    }
    
    /* Range selection styles for round-trip - only for middle dates */
    .custom-datepicker-single-month .react-datepicker__day--in-selecting-range:not(.react-datepicker__day--range-start):not(.react-datepicker__day--range-end) {
      background-color: ${DATE_RANGE_BG} !important;
      color: #333 !important;
    }
    
    .custom-datepicker-single-month .react-datepicker__day--in-range:not(.react-datepicker__day--range-start):not(.react-datepicker__day--range-end) {
      background-color: ${DATE_RANGE_BG} !important;
      color: #333 !important;
    }
    
    /* CRITICAL: Range start MUST show as red, even when in-selecting-range */
    /* This ensures first selected date shows as selected (red), not range color (pink) */
    .custom-datepicker-single-month .react-datepicker__day--range-start.react-datepicker__day--in-selecting-range,
    .custom-datepicker-single-month .react-datepicker__day--range-start.react-datepicker__day--in-selecting-range:hover {
      background-color: ${DATE_SELECTION_BG} !important;
      background: ${DATE_SELECTION_BG} !important;
      color: #fff !important;
      font-weight: 700 !important;
      border-radius: 25% !important;
    }
    
    /* Range start and end should override in-range styles - MUST come after in-selecting-range */
    .custom-datepicker-single-month .react-datepicker__day--range-start,
    .custom-datepicker-single-month .react-datepicker__day--range-start.react-datepicker__day--in-range {
      background-color: ${DATE_SELECTION_BG} !important;
      background: ${DATE_SELECTION_BG} !important;
      color: #fff !important;
      font-weight: 700 !important;
      border-radius: 25% !important;
    }
    
    .custom-datepicker-single-month .react-datepicker__day--range-end,
    .custom-datepicker-single-month .react-datepicker__day--range-end.react-datepicker__day--in-range {
      background-color: ${DATE_SELECTION_BG} !important;
      color: #fff !important;
      font-weight: 700 !important;
      border-radius: 25% !important;
    }
    
    /* Ensure the text is white and visible */
    .custom-datepicker-single-month .react-datepicker__day--range-start:hover,
    .custom-datepicker-single-month .react-datepicker__day--range-end:hover {
      background-color: ${DATE_SELECTION_BG} !important;
      color: #fff !important;
    }
    
    /* Override general hover for selected dates */
    .custom-datepicker-single-month .react-datepicker__day--range-start:hover,
    .custom-datepicker-single-month .react-datepicker__day--range-end:hover {
      background-color: ${DATE_SELECTION_BG} !important;
      color: #fff !important;
      border-radius: 25% !important;
    }
    
    .custom-datepicker-single-month .react-datepicker__day--disabled {
      color: #ccc !important;
      background-color: transparent !important;
      cursor: not-allowed !important;
    }
    .custom-datepicker-single-month .react-datepicker__day--disabled span {
      color: #ccc !important;
    }
    .custom-datepicker-single-month .react-datepicker__day--selected span,
    .custom-datepicker-single-month .react-datepicker__day--range-start span,
    .custom-datepicker-single-month .react-datepicker__day--range-end span {
      color: #fff !important;
    }
    
    .custom-datepicker-single-month .react-datepicker__day--outside-month {
      visibility: hidden !important;
      pointer-events: none !important;
    }
    
    .custom-datepicker-single-month .react-datepicker__day--selected.react-datepicker__day--outside-month {
      background-color: transparent !important;
      color: transparent !important;
      visibility: hidden !important;
    }
    
    .custom-datepicker-single-month .react-datepicker__navigation {
      background-color: transparent !important;
      border: none !important;
      color: ${DATE_SELECTION_BG} !important;
      width: 24px !important;
      height: 24px !important;
      border-radius: 0 !important;
      display: flex !important;
      align-items: center !important;
      justify-content: center !important;
      top: 0 !important;
      padding: 0 !important;
    }
    
    /* Responsive navigation container sizing for single-month calendar */
    @media (max-width: 1024px) {
      .custom-datepicker-single-month .react-datepicker__navigation {
        width: 22px !important;
        height: 22px !important;
      }
    }
    
    @media (max-width: 480px) {
      .custom-datepicker-single-month .react-datepicker__navigation {
        width: 20px !important;
        height: 20px !important;
      }
    }
    
    .custom-datepicker-single-month .react-datepicker__navigation:hover {
      background-color: ${DATE_RANGE_BG} !important;
    }
    
    .custom-datepicker-single-month .react-datepicker__navigation--previous {
      left: 8px !important;
      background-image: url(${arrowSquareLeft}) !important;
      background-size: contain !important;
      background-repeat: no-repeat !important;
      background-position: center !important;
    }
    
    .custom-datepicker-single-month .react-datepicker__navigation--next {
      right: 8px !important;
      background-image: url(${arrowSquareRight}) !important;
      background-size: contain !important;
      background-repeat: no-repeat !important;
      background-position: center !important;
    }
    
    .custom-datepicker-single-month .react-datepicker__navigation-icon {
      display: none !important;
    }
    
    .custom-datepicker-single-month .react-datepicker__navigation-icon::before {
      display: none !important;
    }
    
    .custom-datepicker-single-month .react-datepicker__month-container {
      background-color: #fff !important;
      border-radius: 0 !important;
      margin: 0 !important;
      padding: 0 !important;
      width: 100% !important;
      min-width: 200px !important;
    }
    
    /* Nuclear option - override ALL possible blue highlighting */
    .custom-datepicker-single-month .react-datepicker__day[style*="background-color: rgb(0, 123, 255)"],
    .custom-datepicker-single-month .react-datepicker__day[style*="background-color: #007bff"],
    .custom-datepicker-single-month .react-datepicker__day[style*="background-color: blue"],
    .custom-datepicker-single-month .react-datepicker__day[style*="background-color: rgb(0, 123, 255)"],
    .custom-datepicker-single-month .react-datepicker__day[style*="background-color: #007bff"] {
      background-color: transparent !important;
      color: #333 !important;
    }
    
    /* Override any inline styles that might be added by React DatePicker */
    .custom-datepicker-single-month .react-datepicker__day {
      background-color: transparent !important;
    }
    
    /* Ensure range selection takes priority over the nuclear option */
    /* CRITICAL: This selector applies border-radius, so use same one for color */
    .custom-datepicker-single-month .react-datepicker__day--selected,
    .custom-datepicker-single-month .react-datepicker__day--selected.react-datepicker__day--in-selecting-range,
    .custom-datepicker-single-month .react-datepicker__day--selected.react-datepicker__day--range-start {
      background-color: ${DATE_SELECTION_BG} !important;
      background: ${DATE_SELECTION_BG} !important;
      color: #fff !important;
      border-radius: 25% !important;
    }
    
    /* Range start and end should override in-range styles - higher specificity */
    /* CRITICAL: Force red color for range-start, even with inline styles */
    .custom-datepicker-single-month .react-datepicker__day--range-start,
    .custom-datepicker-single-month .react-datepicker__day--range-start.react-datepicker__day--in-range,
    .custom-datepicker-single-month .react-datepicker__day--range-start.react-datepicker__day--in-selecting-range,
    .custom-datepicker-single-month .react-datepicker__day--range-start.react-datepicker__day--selected {
      background-color: ${DATE_SELECTION_BG} !important;
      background: ${DATE_SELECTION_BG} !important;
      color: #fff !important;
      border-radius: 25% !important;
      font-weight: 700 !important;
    }
    
    /* Force override any inline styles on range-start */
    .custom-datepicker-single-month .react-datepicker__day--range-start[style],
    .custom-datepicker-single-month .react-datepicker__day--selected[style] {
      background-color: ${DATE_SELECTION_BG} !important;
      background: ${DATE_SELECTION_BG} !important;
      color: #fff !important;
    }
    
    /* Override the specific rgba color that might be applied inline */
    .custom-datepicker-single-month .react-datepicker__day--range-start[style*="rgba(171, 38, 69, 0.1)"],
    .custom-datepicker-single-month .react-datepicker__day--range-start[style*="background-color: rgba"],
    .custom-datepicker-single-month .react-datepicker__day--selected[style*="rgba(171, 38, 69, 0.1)"],
    .custom-datepicker-single-month .react-datepicker__day--selected[style*="background-color: rgba"] {
      background-color: ${DATE_SELECTION_BG} !important;
      background: ${DATE_SELECTION_BG} !important;
      color: #fff !important;
    }
    
    .custom-datepicker-single-month .react-datepicker__day--range-end,
    .custom-datepicker-single-month .react-datepicker__day--range-end.react-datepicker__day--in-range {
      background-color: ${DATE_SELECTION_BG} !important;
      color: #fff !important;
      border-radius: 25% !important;
      font-weight: 700 !important;
    }
    
    .custom-datepicker-single-month .react-datepicker__day--in-range:not(.react-datepicker__day--selected):not(.react-datepicker__day--range-start):not(.react-datepicker__day--range-end) {
      background-color: ${DATE_RANGE_BG} !important;
      color: #333 !important;
    }
    
    .custom-datepicker-single-month .react-datepicker__day--in-selecting-range:not(.react-datepicker__day--selected):not(.react-datepicker__day--range-start):not(.react-datepicker__day--range-end) {
      background-color: ${DATE_RANGE_BG} !important;
      color: #333 !important;
    }

    /* Mobile fullscreen date sheet — Figma tokens; must follow legacy single-month rules above */
    .custom-datepicker-single-month.mobile-fullscreen-datepicker .react-datepicker__current-month {
      font-family: 'Host Grotesk', 'Host Grotesk Fallback', 'Host Grotesk Fallback Android', sans-serif !important;
      font-size: 20px !important;
      font-weight: 700 !important;
      color: #252637 !important;
      line-height: 28px !important;
    }

    .custom-datepicker-single-month.mobile-fullscreen-datepicker .react-datepicker__week {
      display: grid !important;
      grid-template-columns: repeat(7, minmax(0, 1fr)) !important;
      width: 100% !important;
    }

    .custom-datepicker-single-month.mobile-fullscreen-datepicker .react-datepicker__day {
      width: 100% !important;
      max-width: none !important;
      min-width: 0 !important;
      height: auto !important;
      min-height: 48px !important;
      flex: none !important;
      font-size: 14px !important;
      font-weight: 600 !important;
      color: #434151 !important;
      border-radius: 0 !important;
    }

    .custom-datepicker-single-month.mobile-fullscreen-datepicker .react-datepicker__day--range-start,
    .custom-datepicker-single-month.mobile-fullscreen-datepicker .react-datepicker__day--range-end,
    .custom-datepicker-single-month.mobile-fullscreen-datepicker .react-datepicker__day--range-start:hover,
    .custom-datepicker-single-month.mobile-fullscreen-datepicker .react-datepicker__day--range-end:hover,
    .custom-datepicker-single-month.mobile-fullscreen-datepicker .react-datepicker__day--range-start.react-datepicker__day--in-selecting-range,
    .custom-datepicker-single-month.mobile-fullscreen-datepicker .react-datepicker__day--range-start.react-datepicker__day--in-range,
    .custom-datepicker-single-month.mobile-fullscreen-datepicker .react-datepicker__day--range-end.react-datepicker__day--in-range,
    .custom-datepicker-single-month.mobile-fullscreen-datepicker .react-datepicker__day--selected,
    .custom-datepicker-single-month.mobile-fullscreen-datepicker .react-datepicker__day--selected:hover,
    .custom-datepicker-single-month.mobile-fullscreen-datepicker .react-datepicker__day--range-start[style],
    .custom-datepicker-single-month.mobile-fullscreen-datepicker .react-datepicker__day--range-end[style],
    .custom-datepicker-single-month.mobile-fullscreen-datepicker .react-datepicker__day--selected[style] {
      background-color: #cf2048 !important;
      background: #cf2048 !important;
      color: #fff !important;
      font-weight: 700 !important;
      border-radius: 3px !important;
    }

    .custom-datepicker-single-month.mobile-fullscreen-datepicker .react-datepicker__day--range-start:not(.react-datepicker__day--range-end) {
      border-radius: 3px 0 0 3px !important;
    }

    .custom-datepicker-single-month.mobile-fullscreen-datepicker .react-datepicker__day--range-end:not(.react-datepicker__day--range-start) {
      border-radius: 0 3px 3px 0 !important;
    }

    .custom-datepicker-single-month.mobile-fullscreen-datepicker .react-datepicker__day--in-range:not(.react-datepicker__day--range-start):not(.react-datepicker__day--range-end),
    .custom-datepicker-single-month.mobile-fullscreen-datepicker .react-datepicker__day--in-range:not(.react-datepicker__day--range-start):not(.react-datepicker__day--range-end):hover,
    .custom-datepicker-single-month.mobile-fullscreen-datepicker .react-datepicker__day--in-selecting-range:not(.react-datepicker__day--range-start):not(.react-datepicker__day--range-end),
    .custom-datepicker-single-month.mobile-fullscreen-datepicker .react-datepicker__day--in-selecting-range:not(.react-datepicker__day--range-start):not(.react-datepicker__day--range-end):hover,
    .custom-datepicker-single-month.mobile-fullscreen-datepicker .react-datepicker__day--in-range:not(.react-datepicker__day--range-start):not(.react-datepicker__day--range-end)[style],
    .custom-datepicker-single-month.mobile-fullscreen-datepicker .react-datepicker__day--in-selecting-range:not(.react-datepicker__day--range-start):not(.react-datepicker__day--range-end)[style] {
      background-color: rgba(255, 222, 229, 0.56) !important;
      background: rgba(255, 222, 229, 0.56) !important;
      color: #434151 !important;
      border-radius: 0 !important;
    }

    .custom-datepicker-single-month.mobile-fullscreen-datepicker .react-datepicker__day--range-start > div > span:first-child,
    .custom-datepicker-single-month.mobile-fullscreen-datepicker .react-datepicker__day--range-end > div > span:first-child,
    .custom-datepicker-single-month.mobile-fullscreen-datepicker .react-datepicker__day--selected > div > span:first-child {
      color: #fff !important;
    }

    /* Gradient border rotation animation */
    @keyframes gradientRotate {
      0% {
        background-image: linear-gradient(white, white), linear-gradient(90deg, #FF0000, #6C27FF, #00B2FF, #BB00FF);
      }
      25% {
        background-image: linear-gradient(white, white), linear-gradient(180deg, #FF0000, #6C27FF, #00B2FF, #BB00FF);
      }
      50% {
        background-image: linear-gradient(white, white), linear-gradient(270deg, #FF0000, #6C27FF, #00B2FF, #BB00FF);
      }
      75% {
        background-image: linear-gradient(white, white), linear-gradient(360deg, #FF0000, #6C27FF, #00B2FF, #BB00FF);
      }
      100% {
        background-image: linear-gradient(white, white), linear-gradient(450deg, #FF0000, #6C27FF, #00B2FF, #BB00FF);
      }
    }

    .gradient-border-animate {
      animation: gradientRotate 2s ease-in-out 1;
    }

    @keyframes fadeIn {
      from {
        opacity: 0;
      }
      to {
        opacity: 1;
      }
    }
  `;
